/* eslint 'jsx-a11y/alt-text': 'off', 'no-redeclare': 'off', 'no-loop-func' : 'off', eqeqeq: 'off' */
import React, { Component } from 'react';
import { connect } from "react-redux";
import { Table, Button, Modal } from 'reactstrap';
import SendEmailForm from '../_ModalsForms/SendEmail';
import classnames from 'classnames';
import ErrorGif from '../../../../../Assets/images/Error.gif';
import { GetTenantGeneratedInvoices, DownloadSelectedInvoice, DeleteInvoices } from '../../../../../action/invoiceAction';
import Currencies from '../../../../../Resources/Currencies';
import DeleteConfirmation from '../_ModalsForms/DeleteConfirmation';
import SearchInput, { createFilter } from 'react-search-input';
import ExcelGif from '../../../../../Assets/images/Excel.GIF';
import PDFGif from '../../../../../Assets/images/PDF.gif';
import Conversions from '../../../../../Resources/Conversions';
import LoadingIndicator from '../../../Common/LoadingIndicator';

const KEYS_TO_FILTERS = ['dateGenerated', 'tenantName', 'invoiceStartDate', 'invoiceEndDate', 'invoiceNumber', 'totalAmount'];

class Invoices extends Component {

    componentWillMount(){
        this.props.GetTenantGeneratedInvoices().then(() => {this.setState({isloading: false})});
    }

    componentWillReceiveProps(nextProps) {
        if (this.props != nextProps) {
            this.setState({ tenants_generated_invoice_data: nextProps.TenantGeneratedInvoices });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            isloading: true,
            modal: false,
            deletemodal: false,
            iserror: false,
            searchTerm: '',
            sort: {
                column: null,
                direction: 'asc',
            },
            tenants_generated_invoice_data:[],
            selected_invoices_for_Email:[]
        };
        this.toggle = this.toggle.bind(this);
        this.validatedelete = this.validatedelete.bind(this);
        this.searchUpdated = this.searchUpdated.bind(this); 
        this.downloadInvoice = this.downloadInvoice.bind(this);      
        this.selectAllCheckbox = this.selectAllCheckbox.bind(this); 
        this.validateEmail = this.validateEmail.bind(this);
    }

    CloseModal = () => {
        this.toggle();
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    selectAllCheckbox(Class_name,main_Check_box) {
        var checkboxes = document.getElementsByClassName(Class_name);
        var main_Check_box = document.getElementById(main_Check_box);
        for (var i = 0; i < checkboxes.length; i++) {
           (main_Check_box.checked === true) ?  checkboxes[i].checked = true :checkboxes[i].checked = false;
        }
      }    

    Delete = (someArg) => {
        if(someArg=="yes"){
          var Data =[];
          var checkboxes = document.getElementsByClassName('InvoiceFileRows');
          for (var i = 0; i < checkboxes.length; i++) {
            if  (checkboxes[i].checked === true) {
                var Invoice_id_to_be_deleted = {
                    "invoiceId" : checkboxes[i].id 
                }
           Data.push(Invoice_id_to_be_deleted);
            } 
            
           }
           if(Data.length>0){
              this.props.DeleteInvoices(Data);
              this.deletetoggle();
           }
           else{
              this.deletetoggle();
           }
      
        }
        else{
          this.deletetoggle();
        }
      }

    validatedelete() {
        this.setState({ iserror: false });
        var IsAnyChecked = false;
        var checkboxes = document.getElementsByClassName('InvoiceFileRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
            }
        }
        if (IsAnyChecked) 
        {
            this.deletetoggle();
        }
        else this.setState({ iserror: true });
    }

    validateEmail(){
        this.setState({ iserror: false,
            selected_invoices_for_Email: [] });
        
        var IsAnyChecked = false;
        var l_Invoices_Data = [];
        var checkboxes = document.getElementsByClassName('InvoiceFileRows');
        for (var i = 0; i < checkboxes.length; i++) {
            if (checkboxes[i].checked === true) {
                IsAnyChecked = true;
                l_Invoices_Data.push(this.state.tenants_generated_invoice_data.filter(x => x.invoiceId == checkboxes[i].id)[0]);
            }
        }
        if (IsAnyChecked) 
        {
            this.setState({selected_invoices_for_Email: l_Invoices_Data });   
            this.toggle();
        }
        else this.setState({ iserror: true});        
    }

    deletetoggle(){
        this.setState({
            deletemodal: !this.state.deletemodal
        });
    }

    downloadInvoice(invoiceId,fileName,fileFormat){
        var fileFormat = (fileFormat == true) ? '.xlsx' : '.pdf';
        this.props.DownloadSelectedInvoice(invoiceId,fileName,fileFormat);
    }

        /* Filter System */

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

     /* Sorting  System */

     onSort = (column,type) => (e) => {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        var data_from_state = this.state.tenants_generated_invoice_data;
        var notequals = 0;
       if(data_from_state != null){
        const sortedData = this.state.tenants_generated_invoice_data.sort((a, b) => {
            //const nameA = isNaN(parseFloat(a[column])) ? parseFloat(a[column]) : a[column].toLowerCase();
            var nameA = null;
            var nameB = null;
            if(type == 'string')
            {
                nameA = a[column].toLowerCase();
                nameB = b[column].toLowerCase();
            }
            else if(type == 'number')
            {
                nameA = parseFloat(a[column]);
                nameB = parseFloat(b[column]);
            }
            else if(type == 'date')
            {
                nameA = new Date(a[column]);
                nameB = new Date(b[column]);
            }

            if (nameA < nameB) {
                notequals = 1;
                return -1;
            }
            if (nameA > nameB) {
                notequals = 1;
                return 1;
            }
            if (nameA == nameB) {
                return 0;
            }
            return 0;
        });

        if(this.state.sort.direction =='asc' && notequals == 1){ 
        sortedData.reverse();
     }

        this.setState({
            sort: {
                column,
                direction,
            }
        });
       }
       else{
           console.log('Not Sorted');
       }
    };

    setArrow = (column) => {
        let className = 'workorder-sort-direction';
        if (this.state.sort.column === column) {
            className += this.state.sort.direction === 'asc' ? ' asccolor' : ' desccolor';
        }
        return className;
    };

    
    render(getLabels, UserPreference_response,UserCanEdit) {
        let error = '', Genearted_Invoice_List = '', data= [], FilteredData = null, lUserCanEdit;
        let label = this.props.getLabels;
        let PreferedDateFormat = this.props.UserPreference_response;

        lUserCanEdit = this.props.UserCanEdit;
        lUserCanEdit = lUserCanEdit !== undefined && lUserCanEdit !== null && lUserCanEdit ? true : false;

        if(this.state.iserror)
        {
            error = <p  className="error_msg">
            <img src={ErrorGif} alt="Trane Logo" /> 
            {label['CheckEmptyInvoice.Text']}
            </p> 
        }

        if(this.state.tenants_generated_invoice_data != undefined && this.state.tenants_generated_invoice_data != null && this.state.tenants_generated_invoice_data.length > 0){
            this.state.tenants_generated_invoice_data.forEach(element => {
                var l_Data = {
                    "artifactName": element.artifactName,
                    "currencyId": element.currencyId,
                    "dateGenerated": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(element.dateGenerated)),
                    "emailAddress": element.emailAddress,
                    "fileName": element.fileName,
                    "invoiceEndDate": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(element.invoiceEndDate)),
                    "invoiceId": element.invoiceId,
                    "invoiceNumber": element.invoiceNumber,
                    "invoiceStartDate": new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'short', day: 'numeric' }).format(new Date(element.invoiceStartDate)),
                    "tenantId": element.tenantId,
                    "tenantName": element.tenantName,
                    "totalAmount": Currencies.CurrencySymbol(element.currencyId)+' '+Conversions.formatNumber(PreferedDateFormat,Number(element.totalAmount).toFixed(2)),
                    "reportFormat": element.isExcelFormat
                }
                data.push(l_Data);
            });
        }

        if (data != undefined && data != null && data.length > 0 && !this.state.isloading) {

            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length != 0) {
                Genearted_Invoice_List = FilteredData.map((el, i) => (
                    <tr Key={i}>
                        <td><input type="checkbox" id={el.invoiceId} className="InvoiceFileRows" /></td>
                        <td>{el.dateGenerated}</td>
                        <td>{el.tenantName}</td>
                        <td>{el.invoiceStartDate}{' - '}{el.invoiceEndDate}</td>
                        <td>{el.reportFormat == true ? <img src={ExcelGif}/> : <img src={PDFGif}/>}</td>
                        <td><label style={{ color: '#6890C6' }} onClick={() => {this.downloadInvoice(el.invoiceId,el.artifactName,el.reportFormat)}}  className="link_cursor">{el.invoiceNumber}</label></td>
                        <td style={{ textAlign: "right" }}>{el.totalAmount}</td>
                    </tr>
                ));
            }
            else {
                Genearted_Invoice_List = <tr><td colSpan="7">No Record Found..</td></tr>
            }
        }
        else if(!this.state.isloading) {
            Genearted_Invoice_List = <tr><td colSpan="7">No Record Found..</td></tr>
        }
        else{
            Genearted_Invoice_List = <tr><td colspan="7" style={{textAlign: 'center'}}><LoadingIndicator/></td></tr>
        }


        return (
          <div className="tenant_content_border">
            <div className="main_container">

                {error}

                <div className="buttons_container">
                    <Button type="button" className="btn btn-black" onClick={this.validateEmail}>{label['TenantInvoices.btnSendEmail.Text']} </Button>
                    <Button type="button" hidden={!lUserCanEdit} className="btn btn-black" onClick={this.validatedelete} >{label['TenantInvoices.btnDelete.Text']}</Button>
                    <SearchInput className="search-input" onChange={this.searchUpdated} />
                </div>

                {/* <div className="filter_container">
                    <Label className="filter_label">For Column</Label>
                    <Input type="select" name="select" className="custom_input default-input select_filter_width" >
                        <option>No filter, view all</option>
                        <option>Tenant</option>
                        <option>Contact Information</option>
                        <option>Buildings</option>
                        <option>Last Invoice Date </option>
                        <option>Last Invoice</option>
                    </Input>
                    <Label className="filter_label">Show Only</Label>
                    <Input type="select" name="select" className="custom_input default-input select_filter_width" >
                        <option>No filter, view all</option>
                    </Input>
                    <Button className="btn-black btn-md" > Apply Filter </Button>
                </div> */}


                <div className="table_container">

                    <Table striped responsive className="Custom_table table_border">
                        <tbody  className="cell_container tenant_cell">
                        <tr>
                                <th><input type="checkbox"  id="main_Check_box" onClick={() => { this.selectAllCheckbox("InvoiceFileRows","main_Check_box"); }} /></th>
                                <th onClick={this.onSort('dateGenerated','date')} className="link_cursor">{label['TenantInvoices.Columns.Date.Text'] !== undefined ? label['TenantInvoices.Columns.Date.Text'] : "Date Generated"}<span className={this.setArrow('dateGenerated')}></span></th>
                                <th onClick={this.onSort('tenantName','string')} className="link_cursor">{label['TenantInvoices.Columns.Tenant.Text'] !== undefined ? label['TenantInvoices.Columns.Tenant.Text'] : "Tenant"}<span className={this.setArrow('tenantName')}></span></th>
                                <th onClick={this.onSort('invoiceStartDate','date')} className="link_cursor">{label['TenantInvoices.Columns.BillPeriod.Text'] !== undefined ? label['TenantInvoices.Columns.BillPeriod.Text'] : "Bill Period"}<span className={this.setArrow('invoiceStartDate')}></span></th>
                                <th >File Format</th>
                                <th onClick={this.onSort('invoiceNumber','string')} className="link_cursor">{label['TenantInvoices.Columns.InvoiceNumber.Text'] !== undefined ? label['TenantInvoices.Columns.InvoiceNumber.Text'] : "Invoice Number"}<span className={this.setArrow('invoiceNumber')}></span></th>
                                <th onClick={this.onSort('totalAmount','number')} className="link_cursor" style={{ textAlign: "right" }}>{label['TenantInvoices.Columns.Amount.Text'] !== undefined? label['TenantInvoices.Columns.Amount.Text'] : "Amount"}<span className={this.setArrow('totalAmount')}></span></th>
                            </tr>
                            {Genearted_Invoice_List}
                        </tbody>
                    </Table>
                </div>

                <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
                    <SendEmailForm selectedInvoices={this.state.selected_invoices_for_Email} CloseModal={this.CloseModal} />
                </Modal>

                <Modal isOpen={this.state.deletemodal} toggle={this.deletetoggle} className={classnames({ classnames: this.props.className }, "ModalContainer short_modal")}>
                    <DeleteConfirmation parentToChildData={[(label['TenantInvoices.DeleteHeader.Text'] !== undefined ? label['TenantInvoices.DeleteHeader.Text'] : "Delete Invoice"),(label["TenantRequest.DeleteUserMessage.Text"] !== undefined ? label["TenantRequest.DeleteUserMessage.Text"] : "You are about to delete a tenant request from the system. Do you want to continue?")]} Delete = {this.Delete}/>
                </Modal>
            </div>
          </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        TenantGeneratedInvoices: state.InvoiceRootReducer.GeneratedInvoiceList,
        getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
        UserPreference_response: state.userPreferencesRootReducer.UserPreference,
        UserCanEdit: state.authService.HasApplicationFullAcess
    };
};

const mapDispatchToProps = dispatch => {
    return {
        GetTenantGeneratedInvoices: () => dispatch(GetTenantGeneratedInvoices()),
        DownloadSelectedInvoice: (invoiceId,fileName,fileFormat) => dispatch(DownloadSelectedInvoice(invoiceId,fileName,fileFormat)),
        DeleteInvoices: (data) => dispatch(DeleteInvoices(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Invoices);